import { MediaPreview } from '@client/new/pages/workout/components/MediaPreview';
import { Button } from '@design-system/components/button/button';
import { Textarea } from '@design-system/components/textarea/textarea';
import { TextInput } from '@client/new/pages/promotions/view/components/TextInput';
import { SubExerciseVM } from '../../../view-model/subexercise.viewmodel';

type ExerciseDetailsProps = {
  exercise: SubExerciseVM;
};

export const ExerciseDetails = ({ exercise: ex }: ExerciseDetailsProps) => {
  return (
    <>
      <TextInput required label="Title" {...ex.register('name')} />
      <Textarea
        label="Description"
        style={{ minHeight: 128 }}
        {...ex.register('description')}
      />
    </>
  );
};

export const ExerciseMedia = ({ exercise: ex }: ExerciseDetailsProps) => {
  if (!ex.media || Object.keys(ex.media).length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'baseline',
        }}
      >
        <Button
          variant="filled"
          color="neutral"
          onClick={() => ex.dispatch('AddMedia')}
        >
          Add +
        </Button>
      </div>
    );
  }

  return (
    <MediaPreview
      media={ex.media}
      videoType="short"
      removeVideo={() => ex.setValue('media', null)}
      disabled={false}
    />
  );
};
